import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { type FC } from "react";

import { type GetPromptsOutput } from "@api/rest/types-and-hooks";
import { labelFor } from "@components/Prompts/constants";
import { type ReportTypeValue } from "@pages/Templates/constants";
import { isPromptValidForReportType } from "@pages/Templates/promptReportType";

/** Flags a field's AI prompt that isn't tagged for the template's report
 * type. Renders nothing when there's no prompt or it fits. */
export const PromptReportTypeBadge: FC<{
  prompt: Pick<GetPromptsOutput, "report_types"> | null | undefined;
  reportType: string;
}> = ({ prompt, reportType }) => {
  if (!prompt || isPromptValidForReportType(prompt, reportType)) return null;
  return (
    // No Mosaic warning token yet; amber matches the other Basecamp warnings.
    <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700">
      <ExclamationTriangleIcon className="h-3.5 w-3.5" aria-hidden="true" />
      Not tagged for {labelFor(reportType as ReportTypeValue)}
    </span>
  );
};
